import { dew as _caching2Dew } from "../caching";
import { dew as _fsDew } from "../../gensync-utils/fs";
import * as _fs4 from "fs";

var _fs3 = "default" in _fs4 ? _fs4.default : _fs4;

var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.makeStaticFileCache = makeStaticFileCache;

  var _caching = _caching2Dew();

  var fs = _fsDew();

  function _fs2() {
    const data = _fs3;

    _fs2 = function () {
      return data;
    };

    return data;
  }

  function makeStaticFileCache(fn) {
    return (0, _caching.makeStrongCache)(function* (filepath, cache) {
      const cached = cache.invalidate(() => fileMtime(filepath));

      if (cached === null) {
        return null;
      }

      return fn(filepath, yield* fs.readFile(filepath, "utf8"));
    });
  }

  function fileMtime(filepath) {
    if (!_fs2().existsSync(filepath)) return null;

    try {
      return +_fs2().statSync(filepath).mtime;
    } catch (e) {
      if (e.code !== "ENOENT" && e.code !== "ENOTDIR") throw e;
    }

    return null;
  }

  return exports;
}